import { PayloadAction } from '@reduxjs/toolkit';
import { isAxiosError } from 'axios';
import { call, put, takeEvery } from 'redux-saga/effects';
import { api, responseErrors } from 'services';
import { notificationContainer } from 'untils/notificationContainer';
import {
  sendEmailFailure,
  sendEmailRequest,
  sendEmailSuccess,
} from './reducer';
import { ISendEmailRequest, ISendEmailResponse } from './types';

function* sendEmailWorker({ payload }: PayloadAction<ISendEmailRequest>) {
  try {
    const response: { data: ISendEmailResponse } = yield call(
      api.mailer.sendEmail,
      payload.body,
    );

    yield put(sendEmailSuccess(response.data));
    yield call(notificationContainer, 'Login link was sent successfully', 'success');
    yield call(payload.onSuccess || (() => undefined));
  } catch (error) {
    yield put(sendEmailFailure());

    if (isAxiosError(error)) {
      responseErrors(error);
    }
  }
}

export function* mailerSaga() {
  yield takeEvery(sendEmailRequest.type, sendEmailWorker);
}
